<template>
  <div class="col-md-12 content-weight">
    <template>
      <p>
        <strong>CashHero</strong> is a financial technology loan service provider. We understand that accessing loan in
        Cambodia can be difficult, and for some, non-existence. That is why <strong>CashHero</strong> exists. Our
        mission is to give everyone access to the fund they need to support their families, grow their business or
        purchase an item that will make life easier.
      </p>
      <p>
        We focus on using technology to provide financial solutions that are fast, simple and reliable. We utilize
        cutting-edge technology to enable easy access to lending services and complement it by offering a quick
        turnaround time, and fast 24-hour disbursement process.
      </p>
      <p>
        Customers applying for financial solutions through us can complete the entire process online, eliminating
        paperworks, complex approval procedures, and guarantors at the same time. Therefore, we have introduced a breath
        of fresh air into Cambodia's finance market, while adding immeasurable value to Cambodian lives.
      </p>
      <p>
        We are a dynamic, highly experienced Information Technology solutions and Financial Technology (FinTech)
        services provider spearheaded by international industry professionals with a significant experience in FinTech
        and IT.
      </p>
      <p>
        <strong>CashHero Co.,Ltd</strong> is a company duly incorporated and registered under the laws of Cambodia.
        <strong>CashHero</strong> operates the online lending platform which connects the borrowers with the licensed
        lender, facilitates loan process and is not acting as a lender or loan provider.
      </p>
    </template>
  </div>
</template>

<script>
export default {
  name: 'AboutUsEnglish'
}
</script>

<style scoped>

</style>
